import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasMediaImported.meta';

export type UseTrackCanvasMediaImportedParams = {
  canvas_id: string;
  number_of_media: number;
  source: 'desktop' | 'workspace' | 'asset_picker';
  board_id?: string;
};

export const useTrackCanvasMediaImported = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasMediaImported = useCallback(
    (params: UseTrackCanvasMediaImportedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasMediaImported };
};
